import React from 'react'

export default () => {
  return (
    <div>
        {/* <p>Looks like we found the culprit! </p> */}
        <h2>This type of dizziness is most likely caused by a condition called  <strong className="text-decoration" data-tip="Episodes of dizziness, motion sensitivity, and/or nausea that may or may not be accompanied by a headache.">Vestibular Migraine</strong> </h2>
        <p>Be sure to visit a healthcare provider to find out what treatments might be available to help reduce the frequency of these migraines.</p>
        <p>Here are some resources that can help you.</p>
        <a id="Vestibular Migraine" href="https://www.rehabmart.com/post/why-am-i-dizzy-top-5-causes-of-dizziness-what-to-do" target="_black">read more about this condition ></a>
    </div>
  )
}
